import { Form } from 'react-bootstrap';
import Select from '../../Select';
import _ from 'lodash';
import { KEYWORDS } from '../../../constants';
import { ConfigInfoSectionProps } from '../LaunchingForm.types';

const ConfigInfoSection = ({
  errors,
  chosenTechs,
  formData,
  onFieldChange,
  validateField,
}: ConfigInfoSectionProps) => {
  return (
    <div className=''>
      <div className='mx-3'>
        <Form.Row>
          <Form.Group className='col mb-2'>
            <Select
              as='select'
              custom
              label='Type de magasin'
              id='businessType'
              value={formData.configurations.businessType}
              onChange={(e) => onFieldChange('configurations.businessType', e.target.value)}
              onBlur={(e) => validateField('configurations.businessType', e.target.value)}
              error={!!errors.configurations?.businessType}
              required
              fullWidth
              name='businessType'
            >
              <option value='' disabled>
                À choisir
              </option>
              {KEYWORDS &&
                _.keys(KEYWORDS).map(key => (
                  <option key={key} value={key}>
                    {key}
                  </option>
                ))}
            </Select>
          </Form.Group>
        </Form.Row>
        {chosenTechs?.webApp ? (
          <Form.Row>
            <Form.Group className='col mb-2'>
              <Form.Label>Référencement</Form.Label>
              <Form.Control
                type='text'
                as='textarea'
                required
                aria-label='With textarea'
                id='keyWords'
                placeholder=''
                value={formData.configurations.keyWords || ''}
                onChange={(e) => onFieldChange('configurations.keyWords', e.target.value)}
              />
            </Form.Group>
          </Form.Row>
        ) : null}
      </div>
    </div>
  );
};

export default ConfigInfoSection;
